<mat-toolbar class="bg-beige-tricon">
  <span class="whitespace-normal" id="grantPteDialogTitle">
    Grant Permission To Enter?
  </span>
</mat-toolbar>

<mat-dialog-content>
  <br>
  <img src="../../assets/images/permission-to-enter.jpg" />
  <br>
  <div id="grantPteLegalText">
    <p></p>
    <p>
      By clicking "I AGREE" below, on behalf of myself and all others on the Lease,
      I authorize a Tricon Employee to perform the requested work while the home is unoccupied.
    </p>
    <br>
    <p>
      Tricon will schedule the work during a 4-hour Visit Window. I consent to being notified via text message:
    </p>
    <ol>
      <li>(a) when the Visit Window is scheduled;</li>
      <li>(b) when the Tricon Employee arrives at my home; and</li>
      <li>(c) when the Tricon Employee leaves my home.</li>
    </ol>
    <p>
      I will ensure the home is safe and ready for service, as instructed.
    </p>
    <br>
    <p>
      If I wish to cancel, I will call Tricon at least 24-hours prior to the scheduled appointment time.
    </p>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="w-full flex flex-col justify-center">
  <button mat-flat-button class="my-2 w-full ml-0" color="primary" mat-dialog-close mat-dialog-close="GRANT_PTE">I
    AGREE</button>
  <!-- This component doesn't render properly without three options. -->
  <button mat-flat-button class="my-2 w-full ml-0" color="primary" mat-dialog-close mat-dialog-close="CANCEL"
    style="display: none">CANCEL</button>
  <button mat-flat-button class="my-2 w-full ml-0" mat-dialog-close mat-dialog-close="DENY_PTE">
    <u>Continue without permission to enter</u></button>
</mat-dialog-actions>
